import { render } from "./CountUp.vue?vue&type=template&id=49311f7f"
import script from "./CountUp.vue?vue&type=script&lang=js"
export * from "./CountUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.39_vue@3.5.39_typescript@6.0.3__webpack@5.108.0_esbuild@0.28.0_postcss@8.5.25_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__